<template>
  <button
    @click="emit('select', tab)"
    :class="
      tab.active ? 'text-utility-brand-700 bg-primary_alt' : 'text-tertiary'
    "
    class="font-semibold text-sm p-3 rounded-md transition-all"
  >
    {{ tab.title }}
  </button>
</template>

<script setup>
const emit = defineEmits(["select"]);

defineProps({
  tab: {
    type: Object,
    required: true,
  },
});
</script>
